export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN';

export const GET_WHITE_LIST = 'GET_WHITE_LIST';

export const DO_LOGIN = 'DO_LOGIN';

export const SAVE_PARTNER_INFO = 'SAVE_PARTNER_INFO';